import Vue from 'vue'
import Vuex from 'vuex'
import Projects from './projects'
import Docs from './docs'

Vue.use(Vuex);

export default new Vuex.Store({
  edit: false,
  feedback: false,
  component: null,
  showForm: false,
  modules: {
    Projects,
    Docs,
  },
  state: {
    resources: null
  },
  mutations: {
    setResources(state, value){
      state.resources = value
    }
  },
})


// WEBPACK FOOTER //
// ./src/store/index.js